// Dashboard data constants
export const DASHBOARD_DATA = {
  totalCredits: 4500,
  totalPurchased: 1200,
  currentPrice: 28.91,
  totalRetired: 1080,
  coinsToRetire: 2350,
  retireCoins: 15
};

// Retirement table data
export const RETIREMENT_DATA = [
  {
    id: 'RI-4345',
    date: '23-04-25',
    coins: 200,
    status: 'Pending'
  },
  {
    id: 'RI-4376',
    date: '24-09-20',
    coins: 400,
    status: 'Completed'
  }
];

// Purchase history data (Enhanced with more entries for history page)
export const PURCHASE_HISTORY = [
  {
    id: 'TXN-001',
    date: '2024-09-24',
    project: 'Amazon Rainforest Conservation',
    coin: 500,
    price: '$32.5',
    total: '$16,250',
    status: 'Completed',
    retired: 500
  },
  {
    id: 'TXN-002',
    date: '2024-09-15',
    project: 'Solar Farm Development India',
    coin: 750,
    price: '$28.75',
    total: '$21,562.5',
    status: 'Completed',
    retired: 394
  },
  {
    id: 'TXN-003',
    date: '2024-09-10',
    project: 'Cookstove Distribution Kenya',
    coin: 273,
    price: '$25',
    total: '$6,825',
    status: 'Pending',
    retired: 0
  },
  {
    id: 'TXN-004',
    date: '2024-08-28',
    project: 'Wind Farm Project Netherlands',
    coin: 1200,
    price: '$30.0',
    total: '$36,000',
    status: 'Completed',
    retired: 1200
  },
  {
    id: 'TXN-005',
    date: '2024-08-20',
    project: 'Mangrove Restoration Project',
    coin: 650,
    price: '$27.5',
    total: '$17,875',
    status: 'Completed',
    retired: 650
  },
  {
    id: 'TXN-006',
    date: '2024-08-15',
    project: 'Solar Farm Development India',
    coin: 400,
    price: '$29.0',
    total: '$11,600',
    status: 'Pending',
    retired: 0
  },
  {
    id: 'TXN-007',
    date: '2024-08-05',
    project: 'Hydroelectric Project Brazil',
    coin: 800,
    price: '$31.25',
    total: '$25,000',
    status: 'Completed',
    retired: 800
  },
  {
    id: 'TXN-008',
    date: '2024-07-25',
    project: 'Forest Conservation Madagascar',
    coin: 950,
    price: '$26.5',
    total: '$25,175',
    status: 'Completed',
    retired: 950
  }
];

// Navigation items
export const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', path: '/enterprise' },
  { id: 'marketplace', label: 'Marketplace', path: '/marketplace' },
  { id: 'history', label: 'History', path: '/history' }
];

// Time period options
export const TIME_PERIODS = [
  { id: 'overall', label: 'Overall' },
  { id: 'annually', label: 'Annually' },
  { id: 'monthly', label: 'Monthly' }
];

// Marketplace data
export const MARKETPLACE_DATA = [
  {
    id: 1,
    title: 'Solar Farm Development India',
    location: 'Kolhapur, Mumbai',
    coins: 3200,
    type: 'solar',
    source: 'solar_plant',
    available: true
  },
  {
    id: 2,
    title: 'Amazon Rainforest Conservation',
    location: 'Kolhapur, Mumbai',
    coins: 5200,
    type: 'forest',
    source: 'forestation',
    available: true
  },
  {
    id: 3,
    title: 'Solar Farm Development India',
    location: 'Kolhapur, Mumbai',
    coins: 5200,
    type: 'solar',
    source: 'solar_plant',
    available: true
  },
  {
    id: 4,
    title: 'Solar Farm Development India',
    location: 'Kolhapur, Mumbai',
    coins: 3200,
    type: 'solar',
    source: 'solar_plant',
    available: true
  },
  {
    id: 5,
    title: 'Solar Farm Development India',
    location: 'Kolhapur, Mumbai',
    coins: 3200,
    type: 'solar',
    source: 'solar_plant',
    available: true
  },
  {
    id: 6,
    title: 'Amazon Rainforest Conservation',
    location: 'Kolhapur, Mumbai',
    coins: 5200,
    type: 'forest',
    source: 'forestation',
    available: true
  },
  {
    id: 7,
    title: 'Amazon Rainforest Conservation',
    location: 'Kolhapur, Mumbai',
    coins: 5200,
    type: 'forest',
    source: 'forestation',
    available: true
  },
  {
    id: 8,
    title: 'Solar Farm Development India',
    location: 'Kolhapur, Mumbai',
    coins: 5200,
    type: 'solar',
    source: 'solar_plant',
    available: true
  }
];